import { useEffect } from "react";
import * as React from "react";
import { Typography, Radio, Form, Input, Select, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import IconButton from "../../ui/IconButton";
import FormHeader from "../FormHeader";
import { CurrencyValue, CurrencySelectionType, EquityPlaceholderName, CompanyPlaceholderName } from "../../../types/newLinkBuilder";
import useFetchCurrencies from "../../../utils/useFetchCurrencies";

interface CurrencyFormProps {
    currencyValue: CurrencyValue;
    setCurrencyValue: (value: CurrencyValue) => void;
    handlePlaceholder: (name: CompanyPlaceholderName) => void;
}

const CurrencyForm: React.FC<CurrencyFormProps> = ({ currencyValue, setCurrencyValue, handlePlaceholder }) => {
    const { currencyOptions, fetchCurrencies } = useFetchCurrencies();

    useEffect(() => {
        fetchCurrencies();
    }, []);

    const handleCurrencyTypeChange = (field: keyof CurrencyValue, value: string) => {
        setCurrencyValue({
            ...currencyValue,
            [field]: value
        })
    }

    return (
        <div>
            <FormHeader title={`Currency Type`} />
                <Typography.Title level={5} style={{ textAlign: 'left' }}>
                    <u>Currency Type</u>
                </Typography.Title>
                <Form.Item
                    name={"currencyType"}
                >
                    <Radio.Group
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                        }}
                        options={[{
                            value: CurrencySelectionType.Value,
                            label: (
                                <Row
                                    align={"middle"}
                                >
                                    <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                        <span>Value</span>
                                    </Col>
                                    <Col span={18} style={{ display: 'flex', justifyContent: 'start' }}>
                                        <Select
                                            placeholder="Currency"
                                            disabled={currencyValue.selected === CurrencySelectionType.CellReference}
                                            value={currencyValue.currency}
                                            onChange={(value) => handleCurrencyTypeChange("currency", value)}
                                            style={{ width: "100%" }}
                                            onClick={(e) => e.preventDefault()}
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={currencyOptions}
                                        />
                                    </Col>
                                </Row>
                            )
                        }, {
                            value: CurrencySelectionType.CellReference,
                            label: (
                                <Row
                                    align={"middle"}
                                >
                                    <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                        <span>Cell Reference</span>
                                    </Col>
                                    <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                                        <Input
                                            placeholder="Currency Type"
                                            disabled={currencyValue.selected === CurrencySelectionType.Value}
                                            value={currencyValue.currencyCellReference}
                                            onChange={(e) => handleCurrencyTypeChange("currencyCellReference", e.target.value)}
                                        />
                                    </Col>
                                    <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                        <IconButton
                                            disabled={currencyValue.selected === CurrencySelectionType.Value}
                                            icon={<UploadOutlined />}
                                            onClick={() => handlePlaceholder(CompanyPlaceholderName.CurrencyCellReference)}
                                        />
                                    </Col>
                                </Row>
                            )
                        }
                        ]}
                    />
                </Form.Item>
        </div>
    )
}

export default CurrencyForm; 